import { memo } from 'react';
import FJModelSelectorPanel from '../../../../common/components/FJModelSelectorPanel/FJModelSelectorPanel';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import FJTextToImageDataConfig, { IMAGE_MODEL_FILTERS } from '../../../../config/dataConfig/FJTextToImageDataConfig';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJTextToImageModelSelectorContainer = memo(function FJTextToImageModelSelectorContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curModel = useSelector(state => state.textToImage.curModel);

    const changeModel = useCallback(
        model => {
            dispatch(FJActionTextToImage.changeModelAction(model.value));
        },
        [dispatch],
    );

    return (
        <FJModelSelectorPanel
            currentModelValue={curModel}
            onSelect={changeModel}
            modelList={FJTextToImageDataConfig.MODELS}
            filterConfig={IMAGE_MODEL_FILTERS}
            boxStyle={{ marginBottom: 20 }}
            offsetLeft={22}
            offsetTop={-21}
        />
    );
});

export default FJTextToImageModelSelectorContainer;
